<template>
    <div class="d-flex align-items-end h-100 pb-3">
        <span class="ml-1">
            <slot name="checkbox" />
        </span>
        <slot name="selection-count" />
    </div>
</template>

<script>
export default {
    name: 'CheckAllContainer',
}
</script>
